import shortId from 'shortid';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';

const makePreferenceKey = (prefix: string, workspaceId: string) => {
  return `${prefix}${workspaceId}` as PREFERENCE_KEYS;
};

export const getWorkspacePreferenceKey = (workspaceId: string) => {
  return makePreferenceKey(TENANT_WORKSPACE_PREFIX, workspaceId);
};

export const TENANT_WORKSPACE_PREFIX = `${PREFERENCE_KEYS.WORKSPACES}__`;

export const generateWorkspacePreferenceKey = () => {
  return makePreferenceKey(TENANT_WORKSPACE_PREFIX, shortId());
};

export const getWorkspaceIdFromPreferenceKey = (key: string) => {
  return key.replace(TENANT_WORKSPACE_PREFIX, '');
};

export const SYSTEM_WORKSPACE_PREFIX = `${PREFERENCE_KEYS.SYSTEM_WORKSPACES}__`;

export const getSystemWorkspacePreferenceKey = (workspaceId: string) => {
  return makePreferenceKey(SYSTEM_WORKSPACE_PREFIX, workspaceId);
};

export const generateSystemWorkspacePreferenceKey = () => {
  return makePreferenceKey(SYSTEM_WORKSPACE_PREFIX, shortId());
};

export const getSystemWorkspaceIdFromPreferenceKey = (key: string) => {
  return key.replace(SYSTEM_WORKSPACE_PREFIX, '');
};
